import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL, DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL } from '../../shared/enderecoSections';
import { termosStep } from '../../shared/termosSections';
import { DOCUMENTOS_OBJETO_E_PE } from '../../shared/certidoesPositivasSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';
import { converterSexo, converterEtnia, converterEstadoCivil, converterDoadorOrgaos, converterExerceFuncaoPublica, DEFICIENCIA_OPCOES, DEFICIENCIA_NAO_POSSUI_ID, SEXO_OPCOES } from '../../shared/catalogosPessoaFisica';

const inscricaoTransferenciaConfig = {
  id: 'inscricao_transferencia',
  nome: 'Inscrição por Transferência',
  descricao: 'Solicitação de inscrição por transferência como advogado OAB/MS',
  icon: 'FaUserPlus',

  documentConfig: {
    required: [
      { id: 'requerimento', tipoDocumentoProcesso: 433, name: 'Requerimento', description: 'Requerimento de inscrição preenchido e assinado', required: true },
      { id: 'declaracaoAutenticidade', tipoDocumentoProcesso: 492, name: 'Declaração de Autenticidade', description: 'Declaração de autenticidade dos documentos apresentados, preenchida e assinada', required: true },
      { id: 'declaracaoIdoneidade', tipoDocumentoProcesso: 318, name: 'Declaração de Idoneidade', description: 'Declaração de idoneidade (modelo padrão)', required: true },
      { id: 'certidaoEstadualCivel', tipoDocumentoProcesso: 514, name: 'Certidão Estadual 1º Grau Cível de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCriminal', tipoDocumentoProcesso: 515, name: 'Certidão Estadual 1º Grau Criminal de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualCrimeMilitar', tipoDocumentoProcesso: 516, name: 'Certidão Estadual 1º Grau Crime Militar de MS', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoEstadualForaEstado', tipoDocumentoProcesso: 526, name: 'Certidão Estadual de 1º Grau Cível, Criminal e Crime Militar – Estado de Origem', description: 'Juntar Certidão Cível, Criminal e Crime Militar em arquivo único PDF', required: true },
      { id: 'certidaoFederalCivel', tipoDocumentoProcesso: 520, name: 'Certidão Federal de 1º e 2º Grau Cível do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCriminal', tipoDocumentoProcesso: 519, name: 'Certidão Federal de 1º e 2º Grau Criminal do TRF3 – Abrangência Regional', description: 'Se positiva, marque na etapa de Termos e anexe a Certidão de Objeto e Pé no campo próprio.', required: true },
      { id: 'certidaoFederalCivelOrigem', tipoDocumentoProcesso: 527, name: 'Certidão Federal de 1º Grau Cível - Estado de Origem', description: 'Certidão federal cível da região de origem', required: true },
      { id: 'certidaoFederalCriminalOrigem', tipoDocumentoProcesso: 528, name: 'Certidão Federal de 1º Grau Criminal - Estado de Origem', description: 'Certidão federal criminal da região de origem', required: true },
      { id: 'certidaoJusticaFederalMilitar', tipoDocumentoProcesso: 503, name: 'Certidão Justiça Federal Militar (STM)', description: 'Expedida pelo Superior Tribunal Militar (STM). Obrigatória para ambos os sexos.', required: true },
      { id: 'certidaoInteiroTeor', tipoDocumentoProcesso: 376, name: 'Certidão de Inteiro Teor', description: 'Certidão de inteiro teor da inscrição seccional de origem', required: true },
      { id: 'copiaIntegralProcesso', tipoDocumentoProcesso: 529, name: 'Cópia Integral do Processo de Inscrição – Seccional de Origem', description: 'Cópia completa do processo de inscrição na seccional de origem', required: true },
      { id: 'tituloEleitor', tipoDocumentoProcesso: 511, name: 'Título de Eleitor', description: 'Título de Eleitor', required: true }
    ],

    conditional: [
      ...DOCUMENTOS_OBJETO_E_PE,
      {
        id: 'certidaoCasamento', tipoDocumentoProcesso: 508,
        name: 'Certidão de Casamento',
        description: 'Certidão de casamento atualizada (obrigatória quando houver alteração de nome por casamento)',
        conditional: true,
        required: true,
        dependsOn: [{ field: 'estadoCivil', value: 'Casado' }, { field: 'nomeDifereIdentificacao', value: 'SIM' }]
      },
      {
        id: 'reservista', tipoDocumentoProcesso: 84,
        name: 'Certificado de Reservista ou Dispensa',
        description: 'Certificado de reservista ou documento de dispensa (obrigatório para homens com menos de 45 anos). Conforme Art. 5º da Lei nº 4.375/1964, maiores de 45 anos são desobrigados.',
        conditional: true,
        required: true,
      },
      {
        id: 'declaracaoResidencia', tipoDocumentoProcesso: 493,
        name: 'Declaração de Residência',
        description: 'Obrigatória quando o endereço residencial informado não estiver em seu nome',
        conditional: true,
        required: true,
        dependsOn: { field: 'enderecoEmSeuNome', value: 'NAO' }
      },
      {
        id: 'cid', tipoDocumentoProcesso: 456,
        name: 'Laudo Médico (CID)',
        description: 'Laudo médico atualizado com CID (obrigatório para PCD)',
        conditional: true,
        required: true,
        dependsOn: { field: 'possuiDeficiencia', notValue: DEFICIENCIA_NAO_POSSUI_ID }
      },
      {
        id: 'atestadoFuncional', tipoDocumentoProcesso: 324,
        name: 'Atestado Funcional',
        description: 'Atestado funcional detalhando atribuições e atividades do cargo (obrigatório para servidores públicos e instituições financeiras)',
        conditional: true,
        required: true,
        dependsOn: { field: 'exerceFuncaoPublica', value: 'SIM' }
      },
      {
        id: 'rgOuCin', tipoDocumentoProcesso: 506,
        name: 'RG / CIN',
        description: 'Registro Geral ou Carteira de Identidade Nacional (CIN)',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'RG_CIN' }
      },
      {
        id: 'cnh', tipoDocumentoProcesso: 507,
        name: 'CNH',
        description: 'Carteira Nacional de Habilitação. Serão aceitas somente emissões a partir de 1º de junho de 2022',
        conditional: true,
        required: true,
        dependsOn: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
      }
    ],
  },

  paymentConfig: {
    amount: 298.00
  },

  protocoloConfig: {
    modeloRequerimento: '188',
    tiposAssunto: '667',
    tipoPedido: '30'
  },

  tituloConfig: {
    tipoLancamentoId: 59,
    enderecoOrigem: 'residencial'
  },

  // Confirmado ao vivo contra GET /modelo-requerimento/188/campos — esse modelo
  // não tem campos de seccional de origem (RegistroConselhoOrigem/DataInscricaoOrigem
  // existem em 189, não em 188), então seccionalOrigem/numeroInscricaoOrigem/
  // dataInscricaoOrigem ficam de fora.
  dadosRequerimentoConfig: mergeDadosRequerimentoConfig(
    {
      campos: [
        { field: 'naturalidade', campoNome: 'Municipio' },
        { field: 'municipioTitulo', campoNome: 'MunicipioTitulo' },
        { field: 'nomeCompleto', campoNome: 'Nome' },
        { field: 'documentoIdentidade', campoNome: 'RG' },
        { field: 'orgaoEmissor', campoNome: 'OrgaoEmissorRG' },
        { field: 'dataEmissao', campoNome: 'DataEmissaoRG' },
        { field: 'cpf', campoNome: 'CPFCNPJ' },
        { field: 'dataNascimento', campoNome: 'DataNascimentoFundacao' },
        { field: 'nomePai', campoNome: 'NomePai' },
        { field: 'nomeMae', campoNome: 'NomeMae' },
        { field: 'tituloEleitor', campoNome: 'TituloEleitor' },
        { field: 'secaoEleitoral', campoNome: 'SecaoTituloEleitor' },
        { field: 'zonaEleitoral', campoNome: 'ZonaTituloEleitor' },
        { field: 'orgaoFuncaoPublica', campoNome: 'NomeOrgaoPublico' },
        { field: 'cargoFuncaoPublica', campoNome: 'NomeCargoPublico' },
        { field: 'cargoFuncaoPublica', campoNome: 'CargoPublico' },
        { field: 'sexo', campoNome: 'Sexo', convert: converterSexo },
        { field: 'etnia', campoNome: 'Etnia', convert: converterEtnia },
        { field: 'estadoCivil', campoNome: 'EstadoCivil', convert: converterEstadoCivil },
        { field: 'doadorOrgaos', campoNome: 'DoadorOrgaos', convert: converterDoadorOrgaos },
        { field: 'exerceFuncaoPublica', campoNome: 'ServidorPublico', convert: converterExerceFuncaoPublica }
      ]
    },
    DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL,
    DADOS_REQUERIMENTO_ENDERECO_PROFISSIONAL
  ),

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { type: 'text', name: 'nomeCompleto', label: 'Nome completo', required: true, placeholder: 'Digite seu nome completo' },
            { type: 'text', name: 'nomePai', label: 'Nome do Pai', placeholder: 'Nome do pai' },
            { type: 'text', name: 'nomeMae', label: 'Nome da Mãe', required: true, placeholder: 'Nome da mãe' },
            { type: 'municipioBusca', name: 'naturalidade', label: 'Naturalidade', required: true, placeholder: 'Digite o nome da cidade de nascimento...' },
            { type: 'paisSelect', name: 'nacionalidade', label: 'Nacionalidade', required: true },
            {
              type: 'select',
              name: 'estadoCivil',
              label: 'Estado Civil',
              required: true,
              options: [
                { value: 'Solteiro', label: 'Solteiro(a)' },
                { value: 'Casado', label: 'Casado(a)' },
                { value: 'Divorciado', label: 'Divorciado(a)' },
                { value: 'Viuvo', label: 'Viúvo(a)' },
                { value: 'UniaoEstavel', label: 'União Estável' }
              ]
            },
            { type: 'date', name: 'dataNascimento', label: 'Data de Nascimento', required: true },
            { type: 'radio', name: 'sexo', label: 'Sexo', required: true, options: SEXO_OPCOES }
          ]
        },
        {
          title: 'Documentos pessoais e eleitorais',
          fields: [
            { type: 'text', name: 'documentoIdentidade', label: 'Documento de Identidade (RG/CIN)', placeholder: 'Nº do RG ou CIN', required: true },
            { type: 'text', name: 'orgaoEmissor', label: 'Órgão Expedidor', placeholder: 'Ex: SSP, DETRAN', required: true },
            { type: 'date', name: 'dataEmissao', label: 'Data Emissão', required: true },
            { type: 'cpf', name: 'cpf', label: 'CPF', required: true },
            { type: 'text', name: 'tituloEleitor', label: 'Título de Eleitor', placeholder: 'Nº do título', required: true },
            { type: 'text', name: 'zonaEleitoral', label: 'Zona do Título', placeholder: 'Zona', required: true },
            { type: 'text', name: 'secaoEleitoral', label: 'Seção do Título', placeholder: 'Seção', required: true },
            { type: 'municipioBusca', name: 'municipioTitulo', label: 'Município do Título', placeholder: 'Digite o nome da cidade...', required: true },
            {
              type: 'radio',
              name: 'tipoDocumentoIdentificacao',
              label: 'Qual documento de identificação você vai enviar?',
              required: true,
              options: [
                { value: 'RG_CIN', label: 'RG / CIN (Carteira de Identidade Nacional)' },
                { value: 'CNH', label: 'CNH (Carteira Nacional de Habilitação)' }
              ],
              defaultValue: 'RG_CIN'
            },
            {
              type: 'dataEmissaoCNH',
              name: 'dataEmissaoCNH',
              label: 'Data de Emissão da CNH',
              required: true,
              showWhen: { field: 'tipoDocumentoIdentificacao', value: 'CNH' }
            }
          ]
        },
        {
          title: 'Declarações pessoais',
          fields: [
            {
              type: 'select',
              name: 'etnia',
              label: 'Etnia (auto-declaração)',
              required: true,
              options: [
                { value: 'Branca', label: 'Branca' },
                { value: 'Negra', label: 'Negra' },
                { value: 'Parda', label: 'Parda' },
                { value: 'Indigena', label: 'Indígena' },
                { value: 'Amarela', label: 'Amarela' },
                { value: 'NaoInformado', label: 'Não informado' }
              ]
            },
            {
              type: 'radio',
              name: 'doadorOrgaos',
              label: 'Doador de Órgãos e Tecidos',
              required: true,
              options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }],
              defaultValue: 'NAO'
            },
            {
              type: 'select',
              name: 'possuiDeficiencia',
              label: 'Deficiência',
              required: true,
              options: DEFICIENCIA_OPCOES,
              defaultValue: DEFICIENCIA_NAO_POSSUI_ID
            },
            {
              type: 'radio',
              name: 'exerceFuncaoPublica',
              label: 'Exerce função/emprego público?',
              required: true,
              options: [{ value: 'SIM', label: 'Sim' }, { value: 'NAO', label: 'Não' }],
              defaultValue: 'NAO'
            },
            {
              type: 'text',
              name: 'orgaoFuncaoPublica',
              label: 'Órgão / Instituição',
              required: true,
              placeholder: 'Ex: Tribunal de Justiça, Ministério Público, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'text',
              name: 'cargoFuncaoPublica',
              label: 'Cargo / Função',
              required: true,
              placeholder: 'Ex: Juiz, Promotor, Analista, etc.',
              showWhen: { field: 'exerceFuncaoPublica', value: 'SIM' }
            },
            {
              type: 'radio',
              name: 'nomeDifereIdentificacao',
              label: 'O nome que consta no seu documento de identificação é diferente do seu nome atual (nome de solteiro(a))?',
              showWhen: { field: 'estadoCivil', value: 'Casado' },
              required: true,
              options: [
                { value: 'SIM', label: 'Sim, meu nome atual é diferente do nome no documento' },
                { value: 'NAO', label: 'Não, meu nome é o mesmo' }
              ],
              defaultValue: 'NAO'
            }
          ]
        },
        {
          title: 'Dados da Seccional de Origem',
          fields: [
            { type: 'text', name: 'seccionalOrigem', label: 'Seccional de Origem', required: true, placeholder: 'Ex: OAB/SP, OAB/RJ' },
            { type: 'text', name: 'numeroInscricaoOrigem', label: 'Número de Inscrição na Seccional de Origem', required: true, placeholder: 'Nº da inscrição' },
            { type: 'date', name: 'dataInscricaoOrigem', label: 'Data da Inscrição na Seccional de Origem', required: true }
          ]
        }
      ]
    },
    enderecoStep({ comProfissional: true, autoCep: true }),
    termosStep(['validadeCertidoes', 'assinaturaDigitalComIdoneidade'], { certidoesPositivas: true })
  ]
};

export default inscricaoTransferenciaConfig;